<template>

<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="17" y="26" width="66.6666" height="49" stroke="black" stroke-width="4"/>
<path d="M47.1525 46.8977L53.4 50.5047L47.1525 54.1117L47.1525 46.8977Z" fill="black" stroke="black" stroke-width="4"/>
<path d="M16.325 34.5999H83.9" stroke="black" stroke-width="4" stroke-dasharray="4 4"/>
<path d="M16.325 66.8416H83.9" stroke="black" stroke-width="4" stroke-dasharray="4 4"/>
</svg>

</template>
